<template>
  <div class="page">
    <PageHeader title="Reports" description="View your workspace's messaging trends" :tabs="tabs">
      <template v-slot:tab-icons>
        <ReportFilters />
      </template>
    </PageHeader>
    <router-view></router-view>
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { ON_REPORT_VIEW_EXIT } from '@/store/reports/actionTypes';
import { RouteLocationNormalized, useRoute, useRouter } from 'vue-router';
import { NLP_ENABLED } from '@/store/app/featureTypes';
import ReportFilters from '@/features/reports/components/ReportFilters.vue';
import { useStore } from 'vuex';
import { computed, watch } from 'vue';

const store = useStore();
const isWorkspaceFeatureEnabled = (feature: string) => computed(() => store.getters.isWorkspaceFeatureEnabled(feature));
const onReportExit = (from: string, to: string) => store.dispatch(ON_REPORT_VIEW_EXIT, { from, to });

const route = useRoute();
const router = useRouter();

watch(
  () => route.path,
  (newPath, oldPath) => {
    if (oldPath?.includes('/reports/')) {
      handleOnTabExit(route, { path: oldPath } as RouteLocationNormalized);
    }
  },
  { immediate: true },
);

//
const tabs = computed<TabItem[]>(() => {
  const tabs = [
    { name: 'Overview', route: 'reports-overview' },
    { name: 'Usage', route: 'reports-usage' },
    { name: 'Flows', route: 'reports-flows' },
  ];

  if (isWorkspaceFeatureEnabled(NLP_ENABLED).value) {
    tabs.push({ name: 'Intents', route: 'reports-intents' });
  }

  return tabs;
});

function handleOnTabExit(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  const fromName = typeof from.name === 'string' ? from.name : String(from.name ?? '');
  const toName = typeof to.name === 'string' ? to.name : String(to.name ?? '');
  onReportExit(fromName, toName);
}
</script>

<style lang="scss" scoped>
.select {
  margin-left: 20px;
}

.icon-adjustment {
  margin-left: -10px;
}

.flow-icon-adjustment {
  margin-top: -4px;
}
</style>
